import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { FilterAccesoModel } from 'src/app/models/acceso/FilterAccesoModel';
import { AccesoEstado, InduccionEstado, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FilterInduccionModel } from 'src/app/models/induccion/FilterInduccionModel';
import { IContratistaAccesoPersonalResult } from 'src/app/models/interfaces/accesos/IContratistaAccesoPersonalResult';
import { IFilterAccesoModel } from 'src/app/models/interfaces/accesos/IFilterAccesoModel';
import { IFilterInduccionModel } from 'src/app/models/interfaces/induccion/IFilterInduccionModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AccesoPersonaService } from 'src/app/services/acceso-personal/acceso-persona.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { AccesoCodigoDialogComponent } from '../acceso-codigo-dialog/acceso-codigo-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-acceso-personal-contratista-lista',
  templateUrl: './acceso-personal-contratista-lista.component.html',
  styleUrls: ['./acceso-personal-contratista-lista.component.css']
})
export class AccesoPersonalContratistaListaComponent implements OnInit {
  modelFilter: IFilterAccesoModel; //IFilterInduccionModel;
  modelListaAccesos: IContratistaAccesoPersonalResult[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  resultsLength = 0;
  currentPage = 0;
  @ViewChild('paginator') paginator!: MatPaginator;

  displayedColumns: string[] = [
    'codigo_solicitud',
    'compania',
    'trabajador',
    'nroDocumentoIdentidad',
    'sede',
    'solicitante',
    'subcontratista',
    'fecha_aprobacion',
    'estado',   
    'fecha_inicio',
    'fecha_fin',
    'acciones',
  ];

  constructor(
    // private induccionService: InduccionService,
    private accesoPersonaService: AccesoPersonaService,
    public dialog: MatDialog,
    private storage: StorageService
  ) { 
    this.modelFilter = new FilterAccesoModel(); //FilterInduccionModel();
    this.modelFilter.pageSize = 30;
    this.modelFilter.estados = [];
    this.modelListaAccesos = new Array<IContratistaAccesoPersonalResult>();
    let usuario = this.storage.getCurrentUser();
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.accesoPersonaService
      .getListPorContratista(this.modelFilter)
      .subscribe((data: SearchResultModel<IContratistaAccesoPersonalResult[]>) => {
        this.modelListaAccesos = data.items;
        this.resultsLength = data.total;
      });
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.accesoPersonaService
      .getListPorContratista(this.modelFilter)
      .subscribe((data: SearchResultModel<IContratistaAccesoPersonalResult[]>) => {
        this.modelListaAccesos = data.items;
        this.resultsLength = data.total;
      });
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    
    this.accesoPersonaService
      .getListPorContratista(this.modelFilter)
      .subscribe((data: SearchResultModel<IContratistaAccesoPersonalResult[]>) => {
        this.modelListaAccesos = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  openDialog(idAccesoPersonal: number): void {
    const dialogRef = this.dialog.open(AccesoCodigoDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: idAccesoPersonal
    });    

    dialogRef.afterClosed().subscribe(result => {
      // this.animal = result;
      // console.log(result);
      // this.service.submit(result).subscribe(p => {
      //   console.log(p);
      // });
    });
  }

  addDays(currentDate: Date, days : number): Date{
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  export() {
    this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.accesoPersonaService.getListPorContratistaToExport(this.modelFilter).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `accesos-personal-contratista-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }
}
